import { useReCaptcha } from "next-recaptcha-v3";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import InputMask from 'react-input-mask';
import { NumericFormat } from "react-number-format";
import { fetchPostEmailSendInsurance } from "../../../services/api";

export default function InsurerForm() {
    const [formPost, setFormPost] = useState({ isLoading: false, isError: false, errorText: '' });
    const { control, register, handleSubmit, setValue, formState: { errors } } = useForm();
    const { executeRecaptcha } = useReCaptcha();

    const onSubmit = async data => {
        const token = await executeRecaptcha("insuranceSubmit");
        setFormPost({ ...formPost, isLoading: true, isError: false, errorText: '', isSuccess: false });
        fetchPostEmailSendInsurance({
            mainConductorAddressLivesWith: data.txtDriverWhoLivesWith,
            mainConductorAddressPostalCode: data.txtDriverResidentialPostalCode,
            mainConductorCivilState: data.ddlDriverMaritalStatus,
            mainConductorCpf: data.txtDriverCPF,
            mainConductorDrivingAtNight: data.ddlDriverDriveAtNight,
            mainConductorGender: data.ddlDriverGender,
            mainConductorHasChild: data.ddlDriverHasSons,
            mainConductorHasDefenseDrivingCourse: data.ddlDriverDefensiveDrivingCourse,
            mainConductorHasResidenceGarage: data.ddlDriverGarageAtResidence,
            mainConductorHasSchoolGarage: data.txtDriverPeriodOfStudy,
            mainConductorHasWork: data.ddlDriverWorks,
            mainConductorHasWorkGarage: data.ddlDriverGarageAtWork,
            mainConductorName: data.txtDriverName,
            mainConductorPeriodOfStudy: data.ddlDriverGarageAtSchool,
            mainConductorPeriodOfWork: data.txtDriverWorkPeriod,
            mainConductorPracticeSport: data.ddlDriverPracticesSports,
            mainConductorSchooling: data.ddlDriverScholarity,
            ownerCellPhone: data.txtOwnerCellPhone,
            ownerCpf: data.txtOwnerCPF,
            ownerEmail: data.txtOwnerEmail,
            ownerName: data.txtOwnerName,
            vehicle: data.txtVehicle,
            vehicleConductorAndInsurerRealtion: data.txtVehicleDriverIsuredRelation,
            vehicleHasAnotherVehicle: data.ddlVehicleHasAnotherVehicle,
            vehicleHasYoungConductor: data.ddlVehicleYoungDriver,
            vehicleIsNew: data.ddlVehicleIsNew,
            vehicleMileagePerMonth: data.txtVehicleKmsPerMonth,
            vehicleUtilization: data.txtVehicleUtilization,
            token
        })
            .then(res => {
                if (res) {
                    setValue('txtDriverWhoLivesWith', '');
                    setValue('txtDriverResidentialPostalCode', '');
                    setValue('ddlDriverMaritalStatus', '');
                    setValue('txtDriverCPF', '');
                    setValue('ddlDriverDriveAtNight', '');
                    setValue('ddlDriverGender', '');
                    setValue('ddlDriverHasSons', '');
                    setValue('ddlDriverDefensiveDrivingCourse', '');
                    setValue('ddlDriverGarageAtResidence', '');
                    setValue('txtDriverPeriodOfStudy', '');
                    setValue('ddlDriverWorks', '');
                    setValue('ddlDriverGarageAtWork', '');
                    setValue('txtDriverName', '');
                    setValue('ddlDriverGarageAtSchool', '');
                    setValue('txtDriverWorkPeriod', '');
                    setValue('ddlDriverPracticesSports', '');
                    setValue('ddlDriverScholarity', '');
                    setValue('txtOwnerCellPhone', '');
                    setValue('txtOwnerCPF', '');
                    setValue('txtOwnerEmail', '');
                    setValue('txtOwnerName', '');
                    setValue('txtVehicle', '');
                    setValue('txtVehicleDriverIsuredRelation', '');
                    setValue('ddlVehicleHasAnotherVehicle', '');
                    setValue('ddlVehicleYoungDriver', '');
                    setValue('ddlVehicleIsNew', '');
                    setValue('txtVehicleKmsPerMonth', '');
                    setValue('txtVehicleUtilization', '');
                    setFormPost({ ...formPost, isLoading: false, isSuccess: true });
                }
            })
            .catch(err => { setFormPost({ ...formPost, isLoading: false, isError: true, errorText: err.toString() }); });
    }
    return (
        <section className="car-listing-section ptb-40">
            <div className="container">
                <div className="row">
                    <div className="col-xl-3">
                        <div className="car_listing_sidebar">
                            <h4 className="mb-2">Seguro</h4>
                            <p className="mb-0">Precisando de seguro para seu veículo? Faça uma cotação on-line conosco.</p>
                            <div className="car_listing_nav mt-4">
                                <ul>
                                    <li><a href="#owner_data" className="active">Dados do Proprietário</a></li>
                                    <li><a href="#main_driver_data">Dados do Condutor Principal</a></li>
                                    <li><a href="#vehicle_data">Dados do Veículo</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-9">
                        <div className="car_listing_form">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="listing_info_box bg-white rounded" id="owner_data">
                                    <h5 className="mb-4">Dados do Proprietário</h5>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Nome Completo</label>
                                                <input type="text" placeholder="Ex.: Joaquim Santos Silva" {...register("txtOwnerName", { required: true })} required={errors.txtOwnerName} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Email</label>
                                                <input type="email" placeholder="Ex.: joaquimsantossilva@yahoo.com" {...register("txtOwnerEmail", { required: true, pattern: /^\S+@\S+$/i })} required={errors.txtOwnerEmail} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>CPF</label>
                                                <InputMask type={'text'} placeholder="Ex.: 333.222.111-00" mask="999.999.999-99" maskChar=" " {...register("txtOwnerCPF", { required: true })} required={errors.txtOwnerCPF} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Celular</label>
                                                <InputMask type={'tel'} placeholder="Ex.: (11) 99999-9999" mask="(99) 99999-9999" maskChar=" " {...register("txtOwnerCellPhone", { required: true })} required={errors.txtOwnerCellPhone} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="listing_info_box bg-white rounded mt-40" id="main_driver_data">
                                    <h5 className="mb-4">Dados do Condutor Principal</h5>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Nome Completo</label>
                                                <input type="text" placeholder="Ex.: Joaquim Santos Silva" {...register("txtDriverName", { required: true })} required={errors.txtDriverName} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>CPF</label>
                                                <InputMask type={'text'} placeholder="Ex.: 333.222.111-00" mask="999.999.999-99" maskChar=" " {...register("txtDriverCPF", { required: true })} required={errors.txtDriverCPF} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Gênero</label>
                                                <select className="form-select" {...register("ddlDriverGender", { required: true })} required={errors.ddlDriverGender}>
                                                    <option value={''}></option>
                                                    <option value={'masculino'}>Masculino</option>
                                                    <option value={'feminino'}>Feminino</option>
                                                    <option value={'outros'}>Outros</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Estado Civil</label>
                                                <select className="form-select" {...register("ddlDriverMaritalStatus", { required: true })} required={errors.ddlDriverMaritalStatus}>
                                                    <option value={''}></option>
                                                    <option value={'solteiro'}>Solteiro(a)</option>
                                                    <option value={'casado'}>Casado(a)</option>
                                                    <option value={'divorciado'}>Divorciado(a)</option>
                                                    <option value={'separado'}>Separado(a)</option>
                                                    <option value={'viúvo'}>Viúvo(a)</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Tem Filhos?</label>
                                                <select className="form-select" {...register("ddlDriverHasSons", { required: true })} required={errors.ddlDriverHasSons}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>CEP Residencial</label>
                                                <InputMask type={'text'} placeholder="Ex.: 02030-010" mask="99999-999" maskChar=" " {...register("txtDriverResidentialPostalCode", { required: true })} required={errors.txtDriverResidentialPostalCode} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Mora Com Quem?</label>
                                                <input type="text" placeholder="Ex.: Mãe, Pai, Esposa..." {...register("txtDriverWhoLivesWith", { required: true })} required={errors.txtDriverWhoLivesWith} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Garagem na Residência?</label>
                                                <select className="form-select" {...register("ddlDriverGarageAtResidence", { required: true })} required={errors.ddlDriverGarageAtResidence}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Trabalha?</label>
                                                <select className="form-select" {...register("ddlDriverWorks", { required: true })} required={errors.ddlDriverWorks}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Período de Trabalho</label>
                                                <input type="text" placeholder="Ex.: Seg. a Sex. das 9:00 as 18:00" {...register("txtDriverWorkPeriod")} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Garagem no Trabalho?</label>
                                                <select className="form-select" {...register("ddlDriverGarageAtWork")}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Escolaridade</label>
                                                <select className="form-select" {...register("ddlDriverScholarity", { required: true })} required={errors.ddlDriverScholarity}>
                                                    <option value={''}></option>
                                                    <option value={'Ensino Fundamental Incompleto'}>Ensino Fundamental Incompleto</option>
                                                    <option value={'Ensino Fundamental Completo'}>Ensino Fundamental Completo</option>
                                                    <option value={'Ensino Médio Incompleto'}>Ensino Médio Incompleto</option>
                                                    <option value={'Ensino Médio Completo'}>Ensino Médio Completo</option>
                                                    <option value={'Superior Completo'}>Superior Completo</option>
                                                    <option value={'Pós-Graduação'}>Pós-Graduação</option>
                                                    <option value={'Mestrado'}>Mestrado</option>
                                                    <option value={'Doutorado'}>Doutorado</option>
                                                    <option value={'Pós-Doutorado'}>Pós-Doutorado</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Período de Estudo</label>
                                                <input type="text" placeholder="Ex.: Seg. a Sex. das 9:00 as 18:00" {...register("txtDriverPeriodOfStudy")} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Garagem no Local de Estudo?</label>
                                                <select className="form-select" {...register("ddlDriverGarageAtSchool")}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Pratica Esportes?</label>
                                                <select className="form-select" {...register("ddlDriverPracticesSports", { required: true })} required={errors.ddlDriverPracticesSports}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Curso de Direção Defensiva?</label>
                                                <select className="form-select" {...register("ddlDriverDefensiveDrivingCourse", { required: true })} required={errors.ddlDriverDefensiveDrivingCourse}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Dirige a noite?</label>
                                                <select className="form-select" {...register("ddlDriverDriveAtNight", { required: true })} required={errors.ddlDriverDriveAtNight}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="listing_info_box bg-white rounded mt-40" id="vehicle_data">
                                    <h5 className="mb-4">Dados do Veículo</h5>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="input-field">
                                                <label>Veículo</label>
                                                <input type="text" placeholder="Ex.: Mercedes benz e 400 coupe 2017" {...register("txtVehicle", { required: true })} required={errors.txtVehicle} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Veículo é 0km?</label>
                                                <select className="form-select" {...register("ddlVehicleIsNew", { required: true })} required={errors.ddlVehicleIsNew}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Condutor Entre 18 e 25 Anos?</label>
                                                <select className="form-select" {...register("ddlVehicleYoungDriver", { required: true })} required={errors.ddlVehicleYoungDriver}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Possui Outro Veículo?</label>
                                                <select className="form-select" {...register("ddlVehicleHasAnotherVehicle", { required: true })} required={errors.ddlVehicleHasAnotherVehicle}>
                                                    <option value={''}></option>
                                                    <option value={'sim'}>Sim</option>
                                                    <option value={'não'}>Não</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Média KM Rodados por Mês</label>
                                                <Controller
                                                    render={({ field: { value, onChange }, formState: { errors } }) => <NumericFormat
                                                        value={value}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        placeholder={'Ex.: 30.000 km'}
                                                        suffix=' km'
                                                        required={errors.txtVehicleKmsPerMonth}
                                                        onValueChange={(v) => onChange(v.formattedValue)} />
                                                    }
                                                    name="txtVehicleKmsPerMonth"
                                                    rules={{ required: true }}
                                                    control={control} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Utilização do Veículo</label>
                                                <input type="text" placeholder="Ex.: Passeio, Trabalho, Estudo..." {...register("txtVehicleUtilization", { required: true })} required={errors.txtVehicleUtilization} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Relação Entre Condutor e Segurado</label>
                                                <input type="text" placeholder="Ex.: O Próprio, Cônjuges, Companheiros, pai/mãe..." {...register("txtVehicleDriverIsuredRelation", { required: true })} required={errors.txtVehicleDriverIsuredRelation} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    formPost.isError
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="error-badge bg-primary-light rounded d-block">{formPost.errorText}</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                {
                                    formPost.isSuccess
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="success-badge bg-primary-success rounded d-block">Ficha de seguro enviada com sucesso, aguarde o retorno de nossa equipe!</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                <div className="form-btns d-flex align-items-center mt-40">
                                    <button
                                        type="submit"
                                        disabled={formPost.isLoading}
                                        className="btn btn-primary-contact">
                                        Enviar Dados<span className="ms-2"><i className="fa-solid fa-arrow-right"></i></span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}